
import { useState, useEffect } from 'react';

const slides = [
  {
    title: 'ESMALTES SEMIPERMANENTES',
    subtitle: 'DNKa · F.O.X · Luna Moon · Touch',
    image: 'https://public.readdy.ai/ai/img_res/5551c13a7a7563651f44315fcb23d1a5.jpg',
    cta: 'Ver Colección'
  },
  {
    title: 'TORNOS PROFESIONALES',
    subtitle: 'Potencia y precisión para manicura perfecta',
    image: 'https://readdy.ai/api/search-image?query=Professional%20electric%20nail%20drill%20machine%20for%20manicure%20with%20elegant%20white%20and%20rose%20gold%20design%20on%20clean%20minimalist%20background%20modern%20beauty%20equipment%20studio%20photography%20with%20soft%20lighting&width=1920&height=800&seq=hero-torno-002&orientation=landscape',
    cta: 'Descubrir Más'
  },
  {
    title: 'FRESAS PROFESIONALES',
    subtitle: 'Carburo, cerámica y diamante',
    image: 'https://readdy.ai/api/search-image?query=Professional%20nail%20drill%20bits%20for%20electric%20manicure%20machine%20small%20metal%20bits%20with%20colorful%20bands%20in%20blue%20red%20silver%20gold%20colors%20various%20shapes%20cone%20flame%20barrel%20ball%20cylinder%20arranged%20on%20white%20surface%20close%20up%20product%20photography%20beauty%20tools&width=1920&height=800&seq=hero-fresas-real-007&orientation=landscape',
    cta: 'Ver Catálogo'
  },
  {
    id: 4,
    title: 'LÁMPARAS UV/LED',
    subtitle: 'Secado rápido y profesional',
    image: 'https://readdy.ai/api/search-image?query=Modern%20professional%20UV%20LED%20nail%20lamp%20with%20sleek%20white%20design%20and%20digital%20display%20on%20clean%20minimalist%20background%20beauty%20equipment%20studio%20photography%20with%20soft%20elegant%20lighting&width=1920&height=800&seq=hero-lampara-005&orientation=landscape',
    cta: 'Ver Modelos'
  },
  {
    title: 'BASES Y TOPS',
    subtitle: 'F.O.X · DNKa · Luna Moon',
    image: 'https://readdy.ai/api/search-image?query=Professional%20nail%20base%20coat%20and%20top%20coat%20bottles%20FOX%20DNKa%20Luna%20Moon%20brands%20on%20elegant%20white%20surface%20beauty%20product%20photography%20with%20soft%20lighting&width=1920&height=800&seq=hero-bases-013&orientation=landscape',
    cta: 'Explorar'
  }
];

export default function HeroSection() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const goToSlide = (index: number) => {
    if (index !== currentSlide && !isTransitioning) {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentSlide(index);
        setIsTransitioning(false);
      }, 300);
    }
  };

  const nextSlide = () => {
    if (!isTransitioning) {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
        setIsTransitioning(false);
      }, 300);
    }
  };

  const prevSlide = () => {
    if (!isTransitioning) {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
        setIsTransitioning(false);
      }, 300);
    }
  };

  const current = slides[currentSlide];

  return (
    <section id="inicio" className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className={`absolute inset-0 bg-cover bg-center transition-opacity duration-500 ${isTransitioning ? 'opacity-0' : 'opacity-100'}`}
        style={{ backgroundImage: `url('${current.image}')` }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-transparent"></div>
      </div>

      {/* Navigation Arrows */}
      <button
        onClick={prevSlide}
        className="absolute left-6 top-1/2 -translate-y-1/2 z-20 w-14 h-14 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-full hover:bg-white/20 transition-all cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-white text-3xl"></i>
      </button>
      <button
        onClick={nextSlide}
        className="absolute right-6 top-1/2 -translate-y-1/2 z-20 w-14 h-14 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-full hover:bg-white/20 transition-all cursor-pointer"
      >
        <i className="ri-arrow-right-s-line text-white text-3xl"></i>
      </button>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div 
          className={`text-center transition-all duration-500 ${isTransitioning ? 'opacity-0 translate-y-4' : 'opacity-100 translate-y-0'}`}
        >
          <h2 className="font-serif text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-6 leading-tight whitespace-pre-line">
            {current.title}
          </h2>

          <p className="text-white/90 text-xl md:text-2xl mb-10">
            {current.subtitle}
          </p>

          <button className="px-10 py-4 bg-white text-stone-900 font-semibold text-sm tracking-wide hover:bg-stone-100 transition-all cursor-pointer whitespace-nowrap">
            {current.cta}
          </button>
        </div>
      </div>

      {/* Slide Indicators */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex items-center gap-3 z-20">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`transition-all duration-300 cursor-pointer ${
              index === currentSlide 
                ? 'w-10 h-1 bg-white' 
                : 'w-6 h-1 bg-white/40 hover:bg-white/60'
            }`}
          />
        ))}
      </div>
    </section>
  );
}
